module.exports = __webpack_public_path__ + "img/woman-leg-back.5f83ec0d.png";